import React from 'react';

const PageNotFound = () => {
  return <>
    <h1 style={{ marginTop: '150px', textAlign: 'center' }}>
      Page Not Found
    </h1>
  </>;
};

export default PageNotFound;